<template lang="pug">
	
	.responsive-image
		.image-wrapper
			img(:src="img").image

</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import $ from 'jquery'
	import { TweenMax } from 'gsap'
	
  @Component({
		name: 'ResponsiveImage',
		components: {  },
		props: ["width","height","src"],
		data: function () {
			return {
				img: undefined
			}
		}
	})

	class ResponsiveImage extends Vue {

		mounted () {
			this.init()
		}

		init () {

			this._dom()
			this._setPadding()
			this.load()
		}

		load () {

			let bufferImg = new Image()
			bufferImg.onload = () => {
				this.img = this.src
			}
			bufferImg.src = this.src

		}


		_dom () {
			this.$wrapImage = this.$el.querySelector('.image-wrapper')
		}

		_setPadding () {
			this.$wrapImage.style.paddingBottom = `${(this.height/this.width) * 100}%`
		}

		_resize () {

		}	

	}

	export default ResponsiveImage

</script>


<style lang="stylus">
	
	@import '../theme/utils'
	@import '../theme/variables'
	
	.responsive-image
		position relative
		width 100%

		.image-wrapper
			width 100%
			position relative

			.image
				position absolute
				top 0
				left 0
				width 100%
		

</style>


// WEBPACK FOOTER //
// responsive-image.vue?e7dab884